<template>
  <div class="stockWarning column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center flex-wrap">
        <div class="width250">
          <el-select v-model="selectHouse" placeholder="请选择库房" style="width: 100%;" filterable>
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width250 margin-left20">
          <el-input placeholder="请输入药品名称" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="row-me row-center margin-left20">
          <el-checkbox v-model="checked1">
            <div class="row-me row-center">
              <div class="orange-div"></div>
              <div class="margin-left10">库存不足</div>
            </div>
          </el-checkbox>
          <el-checkbox v-model="checked2" class="margin-left50">
            <div class="row-me row-center">
              <div class="red-div"></div>
              <div class="margin-left10">近效期</div>
            </div>
          </el-checkbox>
        </div>
        <div class="flex1"></div>
        <div class="row-me row-center margin-left20">
          <div class="btn-blue width100 btn-height40" @click="clickSearch">
            <el-icon>
              <search/>
            </el-icon>
            查询
          </div>
          <div class="btn-blank width100 btn-height40 margin-left20" @click="clickClear">清空</div>
        </div>
      </div>
      <div class="column-me flex1 margin-top20">
        <div>
          <el-table ref="tableStockWarning" :data="tableData" border
                    header-cell-class-name="table-header-style" cell-class-name="table-cell-font"
                    :row-class-name="tableRowClassName" @row-click="clickTableRow"
                    @cell-mouse-enter="cellMouseEnter">
            <el-table-column type="expand">
              <template #default="scope">
                <div class="margin-left15 margin-right15">
                  <el-table :data="scope.row.details" border
                            header-cell-class-name="table-header-style" cell-class-name="table-cell-style"
                            height="100%">
                    <el-table-column prop="batchNo" label="批号" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="validityTime" label="有效期" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="nums" label="申请数量" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="avaNums" label="库存数量" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="costPrice" label="入库价" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="producerName" label="生产商" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="supplierName" label="供应商" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="produceTime" label="生产日期" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="productAddress" label="产地" align="center" show-overflow-tooltip>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="库房名称" align="center" show-overflow-tooltip>
              <template #default='scope'>
                <div class="row-me row-center">
                  <div class="row-me row-center" style="width: 40px;">
                    <div class="orange-div margin-right10" v-if="scope.row.nums<scope.row.earlyNum">
                    </div>
                    <div class="red-div margin-right10"
                         v-if="scope.row.drugId!==''&&scope.row.drugId!==null"></div>
                  </div>
                  <div>{{ scope.row.pharmacyName }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="药品名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="normalPrice" label="常规价" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="granulePrice" label="颗粒价" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="unit" label="单位" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="spec" label="规格" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="earlyNum" label="预警数量" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="innums" label="入库数量" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outnums" label="出库数量" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="nums" label="库存数量" align="center" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <div class="margin-top20">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      selectHouse: '',
      name: '',
      checked1: false,
      checked2: false,
      tableData: [],
      pageNo: 1,
      total: 0,
      houseArray: [],
    }
  },
  // html加载完成之前
  created() {
    this.getHouseList()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    clickTableRow(row, index, e) {
      this.$refs.tableStockWarning.toggleRowExpansion(row)
    },
    cellMouseEnter(row, column, cell, event) {
      this.$getRequest('/admin/stock/getInStorageBatchNos', {
        id: row.id,
        pharmacyId: row.pharmacyId,
      }).then((res) => {
        if (res) {
          row.details = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //查询
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      if (this.houseArray.length > 0) {
        this.selectHouse = this.houseArray[0].id
      }
      this.name = ''
      this.checked1 = false
      this.checked2 = false
      this.pageNo = 1
      this.getData()
    },
    //行颜色
    tableRowClassName({row, rowIndex}) {
      if (row.drugId !== '' && row.drugId !== null) {
        return 'text-red'
      } else if (row.nums < row.earlyNum) {
        return 'text-orange'
      }
      return ''
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //获取数据
    getData() {
      let param = {
        pharmacyId: this.selectHouse,
        name: this.name,
        pageNumber: this.pageNo,
      }
      let type = '';
      if (this.checked1 && !this.checked2) {
        type = 0
      }
      if (!this.checked1 && this.checked2) {
        type = 1
      }
      if (this.checked1 && this.checked2) {
        type = 2
      }
      if (type !== '') {
        param.type = type
      }
      this.$getRequest('/admin/stock/pageStockWaring', param).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    }, //获取库房列表
    getHouseList() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
          if (this.houseArray.length > 0) {
            this.selectHouse = this.houseArray[0].id
          }
          this.pageNo = 1
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.stockWarning {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;

    .orange-div {
      width: 10px;
      height: 10px;
      background: #FFB23F;
    }

    .red-div {
      width: 10px;
      height: 10px;
      background: #FF6969;
    }
  }
}
</style>
